/**
 * 該当件数の集計プラグイン
 *
 * 渡されたルート配下の **[data-child] の中にあるチェックボックス** のうち
 * チェック済みのものの data-count / data-count-lot を合算し、countChange で通知する。
 *
 * 【何を合算しているのか（2026-08-21 追記）】
 * 合算対象はエリア軸の選択肢＝**市区町村 / 駅 / 学校**であって、物件種別ではない。
 * 種別タブ（.c-search-type-tabs）は同日にチェックボックスからラジオ（単一選択）へ
 * 変わったが（設計メモ D25）、そもそも各ページで [data-pickup-search] の**外**に
 * 置かれており、ここの querySelectorAll には最初から入っていない。
 * よってラジオ化による影響は無く、合算の意味も変わっていない
 * （市区町村を3つ選べば3市区分の合計、という従来どおりの動き）。
 *
 * 種別を変えたときの流れは
 *   種別ラジオ change → *-type-filter.js が件数APIを叩き data-count を差し替え
 *   → listRoot に countRecalc を投げる → ここが同じ規則で再集計
 * で、種別ごとの件数を足し合わせる経路はどこにも無い。
 */
class CountAction {
    constructor(targetObj, params){
        if(!targetObj) return;
        this.settings = {
            ...this.defaults(),
            ...params,
        }
        this.targetObj = targetObj;
        this.chkObjs = targetObj.querySelectorAll('input[type="checkbox"]');
        this.init();
    }

    defaults(){
        return {
        }
    }

    init(){
        this.chkObjs.forEach((obj) => {
            obj.addEventListener('change', (e) => {
                setTimeout(() => {
                    this.count();
                }, 100);
            });
        });

        // ブラウザバック対応
        setTimeout(() => {
            this.count();
        }, 400);

        // 外部から data-count 更新後に再集計させるためのイベント（例: AJAXでの件数再取得後）
        this.targetObj.addEventListener('countRecalc', () => this.count());
    }

    count() {
        // 合算対象はエリア軸（市区町村/駅/学校）の複数選択。種別ではない（クラスのコメント参照）
        let countAll = 0;
        let lotCountAll = 0;
        this.chkObjs.forEach((obj) => {
            if(obj.closest('[data-child]') == null) return; // 親要素はスキップ
            // 子要素のカウント数を集計
            if (obj.checked) {
                // 件数の要素は必ずあるとは限らない。こだわり条件ページのように件数を出さない
                // チェックボックス（is_hide_count）ではspanごと描画されないため、
                // 無ければ0として素通りさせる（ここで例外を投げると集計全体が止まる）
                const label = obj.closest('label');
                countAll += Number(label?.querySelector('[data-count]')?.dataset.count || 0);
                // 分譲地の数。画面に出していない data-count-lot から拾う
                lotCountAll += Number(label?.querySelector('[data-count-lot]')?.dataset.countLot || 0);
            }
        });
        // count は従来どおりプラン（多棟の親を含まない物件数）。受け手を壊さないようキー名を変えない
        this.targetObj.dispatchEvent(new CustomEvent('countChange', { detail: { count: countAll, lotCount: lotCountAll } }));
    }

    on(eventName, callback) {
        this.targetObj.addEventListener(eventName, function (e) {
            callback(e.detail);
        });
    }
}

export default CountAction;
